module.exports = __webpack_public_path__ + "static/media/help_redlines.b6286a5f.png";